// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".defaultTheme .message-hint[data-v-7d70360c]{--hint-color:var(--base-color-white)}.darkTheme .message-hint[data-v-7d70360c]{--hint-color:var(--base-color-text-regular)}.message-hint[data-v-7d70360c]{font-size:var(--base-font-size-extra-small);color:var(--hint-color);height:var(--base-size-48);line-height:var(--base-size-48);text-align:center}", ""]);
// Exports
module.exports = exports;
